<script setup lang="ts">
import type { List } from '~~/src/types/list'

interface IProps {
  lists?: List[]
  canLoadMore?: boolean
  loading?: boolean
  isSearching?: boolean
  variant?: 'main-item' | 'side-item' | 'search-item'
}

interface IEmits {
  (e: 'loadMore'): void
  (e: 'reachedEnd'): void
}

defineProps<IProps>()
const emit = defineEmits<IEmits>()
const containerRef = ref<HTMLElement>()

useInfiniteScroll(
  containerRef,
  () => emit('reachedEnd'),
  { distance: 100 },
)

let observer: ResizeObserver
// whenever(containerRef, (container) => {
//   observer = new ResizeObserver(() => {
//     if (container.scrollHeight <= container.clientHeight)
//       emit('reachedEnd')
//   })

//   observer.observe(container)
// })
// onUnmounted(() => observer?.disconnect())
</script>

<template>
  <div h-full>
    <div v-if="lists && lists.length > 0" h-full>
      <div
        ref="containerRef"
        flex="~ col"
        h-full
      >
        <TransitionGroup name="fade">
          <div v-for="(list, index) in lists" :key="index">
            <ListCard
              :list="list"
              :variant="variant"
              :first-item="index === 0"
            />
          </div>
        </TransitionGroup>
      </div>

      <div v-if="canLoadMore">
        <AppButton
          variant="outline"
          w-max mx-auto mt-5
          :enabled="!loading"
          @click="!loading && $emit('loadMore')"
        >
          Load More
        </AppButton>
      </div>
    </div>

    <Text v-else key="not-found" variant="small" text-bluish-softer text-center mt-5 mb-4>
      <slot v-if="!isSearching" name="not-searching">
        Start typing to search.
      </slot>
      <slot v-else-if="loading" name="loading">
        Loading...
      </slot>
      <slot v-else name="not-found">
        No lists found.
      </slot>
    </Text>
  </div>
</template>
